import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[#181818] bg-black" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-16 grid grid-cols-2 md:grid-cols-4 gap-10 text-sm">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <img
              src="/brand/bliencer-mark.png"
              alt=""
              aria-hidden
              className="h-8 w-8 squircle-sm object-contain bg-white p-1"
            />
            <span className="text-white font-semibold tracking-tight text-lg">Bliencer</span>
          </div>
          <p className="text-[#a0a0a0] leading-relaxed max-w-xs">
            100% human editors. Human creatives. Viral content crafted by professionals for
            creators who demand real quality.
          </p>
        </div>
        <div>
          <div className="text-white font-medium mb-4">Product</div>
          <ul className="space-y-2 text-[#a0a0a0]">
            <li><a href="/#how" className="hover:text-white">How it works</a></li>
            <li><a href="/#styles" className="hover:text-white">Editing styles</a></li>
            <li><a href="/#pricing" className="hover:text-white">Pricing</a></li>
            <li><Link to="/order" className="hover:text-white">Start an order</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-white font-medium mb-4">Company</div>
          <ul className="space-y-2 text-[#a0a0a0]">
            <li><a href="/#faq" className="hover:text-white">FAQ</a></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            <li><Link to="/affiliate" className="hover:text-white">Affiliate program</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-white font-medium mb-4">Legal</div>
          <ul className="space-y-2 text-[#a0a0a0]">
            <li>Terms of service</li>
            <li>Privacy policy</li>
            <li>NDA on request</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#181818] py-6 text-center text-xs text-[#7a7a7a]">
        © {new Date().getFullYear()} Bliencer Studio. Built for creators.
      </div>
    </footer>
  );
}
